import React from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import {
  getHasLoadedOptions, getLeaveRolloverOptions, getProcessingPayrollOptions, getPayePaymentsFrequencyOptions, getCompetingProducts,
} from 'store/modules/options/selectors';
import { IReducerState, history } from 'store/main-reducer';
import { CallbackRequestModal } from 'views/components/CallbackRequestModal/CallbackRequestModal';
import {
  getBank, getPayrollData, getIsAccountant, getAccountantWillPaySmartPayrollFees, getIsCalcOnly,
} from 'store/modules/sign-up/selectors';
import { IPayroll } from 'types';
import { actionSetPayroll } from 'store/modules/sign-up/actions';
import { PayrollView } from './Payroll';

interface Props {
  intl: IntlShape;
  defaultValues?: IPayroll;
  saveStepPayroll: typeof actionSetPayroll;
  hasLoadedOptions: boolean;
  bank: string;

  processingPayrollOptions: string[];
  competingProducts: string[];
  payePaymentsFrequencyOptions: string[];
  leaveRolloverOptions: string[];

  isAccountant: boolean;
  accountantWillPaySmartPayrollFees: boolean;

  isCalcOnly: boolean;
}

const PayrollController = (props: Props) => {
  const {
    intl,
    hasLoadedOptions,
    bank,
    processingPayrollOptions,
    payePaymentsFrequencyOptions,
    leaveRolloverOptions,
    saveStepPayroll,
    defaultValues,
    isAccountant,
    accountantWillPaySmartPayrollFees,
    isCalcOnly,
    competingProducts,
  } = props;

  const goToNextStep = (data: IPayroll) => {
    saveStepPayroll(data);

    history.push('/sign-up/summary');
  };

  const goToPreviousStep = () => {
    history.push('/sign-up/company-details');
  };

  if (!hasLoadedOptions) {
    history.push('/');
  }

  return (
    <>
      <PayrollView
        intl={intl}
        goToNextStep={goToNextStep}
        goToPreviousStep={goToPreviousStep}
        bank={bank}
        processingPayrollOptions={processingPayrollOptions}
        payePaymentsFrequencyOptions={payePaymentsFrequencyOptions}
        leaveRolloverOptions={leaveRolloverOptions}
        defaultValues={defaultValues}
        isAccountant={isAccountant}
        accountantWillPaySmartPayrollFees={accountantWillPaySmartPayrollFees}
        isCalcOnly={isCalcOnly}
        competingProducts={competingProducts}
      />
      <CallbackRequestModal />
    </>
  );
};


const mapStateToProps = (state: IReducerState) => ({
  hasLoadedOptions: getHasLoadedOptions(state),
  bank: getBank(state),
  processingPayrollOptions: getProcessingPayrollOptions(state),
  payePaymentsFrequencyOptions: getPayePaymentsFrequencyOptions(state),
  leaveRolloverOptions: getLeaveRolloverOptions(state),
  defaultValues: getPayrollData(state),
  isAccountant: getIsAccountant(state),
  accountantWillPaySmartPayrollFees: getAccountantWillPaySmartPayrollFees(state),
  isCalcOnly: getIsCalcOnly(state),
  competingProducts: getCompetingProducts(state),
});

const mapDispatchToProps = {
  saveStepPayroll: actionSetPayroll,
};

export const Payroll = injectIntl(connect(
  mapStateToProps,
  mapDispatchToProps,
)(PayrollController));
